import { render, staticRenderFns } from "./TransferEntityDetails.vue?vue&type=template&id=47e0a0b4&scoped=true&"
import script from "./TransferEntityDetails.vue?vue&type=script&lang=js&"
export * from "./TransferEntityDetails.vue?vue&type=script&lang=js&"
import style0 from "./TransferEntityDetails.vue?vue&type=style&index=0&id=47e0a0b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e0a0b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e0a0b4')) {
      api.createRecord('47e0a0b4', component.options)
    } else {
      api.reload('47e0a0b4', component.options)
    }
    module.hot.accept("./TransferEntityDetails.vue?vue&type=template&id=47e0a0b4&scoped=true&", function () {
      api.rerender('47e0a0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TransferEntityDetails.vue"
export default component.exports